import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const requiredRoles = route.data?.['roles'] as Array<string>;

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const userRole = auth.getRole();

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (userRole && requiredRoles.includes(userRole)) {
    return true;
  }

  // Redirect to home if user doesn't have the required role
  return router.createUrlTree(['/home']);
};
